import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/content";
import { Reveal } from "./Reveal";

export const Faq = () => (
  <section data-testid="faq-accordion-section" className="pb-24 lg:pb-32">
    <div className="max-w-[1000px] mx-auto px-4 sm:px-8">
      <Reveal>
        <Accordion type="single" collapsible className="border-t border-[#1B1530]/15">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`q${i}`} className="border-[#1B1530]/15">
              <AccordionTrigger data-testid={`faq-item-trigger-${i}`} className="py-6 text-left font-display text-2xl sm:text-3xl hover:no-underline hover:text-[#FF5A5F]">{f.q}</AccordionTrigger>
              <AccordionContent data-testid={`faq-item-content-${i}`} className="text-base sm:text-lg text-[#4A4560] leading-relaxed pb-6 max-w-2xl">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
